import React, { useCallback } from 'react';
import { generateId } from '@adp-wfn/mdf-core';
import { SdfActionMenu, SdfMenu } from '@waypoint/react-components';
import ValidElementChildren from '@synerg/vdl-react-components/lib/util/valid-element-children.js';
import { iconMapper } from '../util/iconMapper';

const validPositions = ['auto', 'auto-end', 'auto-start', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start'];

export const ActionMenu2 = ({
  buttonClassName,
  children,
  disabled,
  emphasis,
  iconClass,
  id,
  menuLabel,
  position,
  portalDisabled,
  size,
  onSdfChange,
  ...props
}) => {
  const handleChange = useCallback((event: any) => {
    onSdfChange?.(event);
  }, [onSdfChange]);

  const actionId = id ?? generateId('mdf-ActionMenu2-Container');

  // For backward compatibility, the MDF ActionMenus need to be portal-enabled.
  // Use the portalDisabled property to turn off backward compatibility.
  const menuProps: any = {
    disabled: disabled ? true : undefined,
    emphasis: emphasis ?? 'tertiary',
    id: actionId,
    'portal-enabled': !portalDisabled
  };

  if (buttonClassName) {
    menuProps.className = buttonClassName;
  }

  if (iconClass) {
    menuProps.icon = iconMapper(iconClass);

    // Don't duplicate the expand icon
    if (menuProps.icon.includes('action-expand')) {
      delete menuProps.icon;
    }
  }

  if (menuLabel) {
    menuProps.label = menuLabel;
  }
  else {
    menuProps['icon-only'] = true;

    if (props['aria-label']) {
      menuProps.label = props['aria-label'];
    }
    else if (props.ariaLabel) {
      menuProps.label = props.ariaLabel;
    }
  }

  if (position) {
    if (validPositions.includes(position)) {
      menuProps.attachment = position;
    }
  }

  if (size) {
    menuProps.size = size === 'lg' || size === 'xl' ? 'md' : 'sm';
  }

  // Clone the children so that they get fully re-rendered and new event parameters are picked up
  const cloneChildren = () => {
    return ValidElementChildren.map(children, (child: React.JSX.Element, index: number) => {
      return React.cloneElement(child, {
        id: `${actionId}_menuitem_${index}`,
        key: `${actionId}-${index}`
      });
    });
  };

  return (
    <SdfActionMenu {...menuProps} onSdfChange={handleChange}>
      <SdfMenu>
        {cloneChildren()}
      </SdfMenu>
    </SdfActionMenu>
  );
};

ActionMenu2.displayName = 'ActionMenu2';
